import { FC } from "react";
import { IconAnimation } from "../../components/animation";
import { CloseIcon } from "../../assets/icons";
import { usePopupStore, useThemeStore } from "../../stores";

const PopupClose: FC = () => {
  const theme = useThemeStore((state) => state.theme);
  const setPopupBody = usePopupStore((state) => state.setPopupBody);
  const onClick = (): void => {
    setPopupBody(null);
  };
  return (
    <IconAnimation
      Icon={CloseIcon}
      onHoverColor={theme.alert}
      style={{
        position: "absolute",
        top: 5,
        right: 10,
        cursor: "pointer",
        zIndex: 99999,
      }}
      onClick={onClick}
      width={24}
      height={24}
    />
  );
};

export default PopupClose;
